import { useOrganizationStore, useUserStore } from 'store/modules';

export default function (to, from, next) {
    const userStore = useUserStore();
    const organizationStore = useOrganizationStore();

    const config = userStore.config;
    const organizationSettings = organizationStore.organizationSettings;
    const userSettings = userStore.userSettings;
    const salesmsgDesignV2 = Boolean(
        userSettings?.find((setting) => setting.key === 'salesmsg-design-v2')?.settings['active']
    );

    if (salesmsgDesignV2) {
        next();
        return;
    }

    let tenDLCSettings = null;

    if (Array.isArray(organizationSettings)) {
        tenDLCSettings = organizationSettings?.find((setting) => setting?.key === '10dlc_banners');
    }

    if (config && tenDLCSettings?.settings?.active) {
        const time = config?.['10dlc_banners_info']?.grace_period;
        const isActive = config?.['10dlc_banners_info']?.should_show_banner;

        const expired = time?.days_left === 0 && time?.hours_left === 0;

        if (expired && isActive && to.name !== 'settings.organization.compliance') {
            if (window?.TenDLCBanner?.showModal) window.TenDLCBanner.showModal();

            if (!window.location.pathname.includes('/widget')) {
                next('/settings/organization/compliance');

                return;
            }
        }

        next();
        return;
    }

    next();
}
